import React from "react";

export default function QuoteIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="37"
      height="28"
      fill="none"
      viewBox="0 0 37 28"
      {...props}
    >
      <path
        fill="#3B82F6"
        d="M3.666 25.642C1.606 23.454.5 21 .5 17.022c0-7 4.914-13.274 12.06-16.376l1.786 2.756c-6.67 3.608-7.974 8.29-8.494 11.242 1.074-.556 2.48-.75 3.858-.622 3.608.334 6.452 3.296 6.452 6.978a7 7 0 01-7 7 7.743 7.743 0 01-5.496-2.358zm20 0C21.606 23.454 20.5 21 20.5 17.022c0-7 4.914-13.274 12.06-16.376l1.786 2.756c-6.67 3.608-7.974 8.29-8.494 11.242 1.074-.556 2.48-.75 3.858-.622 3.608.334 6.452 3.296 6.452 6.978a7 7 0 01-7 7 7.743 7.743 0 01-5.496-2.358z"
      ></path>
    </svg>
  );
}
